<template>
    <div class="a-card" :class="[{ borders }, `${removePadding ? '' : 'pa-5'}`, {fit: heightFitContent}, { 'flex-active': activateFlex }]"
        :style="computedStyles"
    >
        <div v-if="title || iconOptions" class="top mb-3">
            <div class="text-wrapper d-flex align-items-center flex-wrap">
                <div v-if="title" class="a-card-title w-full">
                    <h6>{{ title }}</h6>
                </div>
                <div v-if="desc" class="a-card-desc w-full mt-1">
                    <p>{{ desc }}</p>
                </div>
            </div>
            <div v-if="iconOptions"
                class="action-icon"
                v-tooltip="{
                    content: iconOptions.tooltipText,
                    delay: { show: 500, hide: 100 },
                }"
                @click="$emit('action-clicked')"
            >
                <font-awesome-icon :icon="`${iconOptions.iconStyle} ${iconOptions.iconName}`" class="icon castle-moat--text" />
            </div>
            <slot name="header-append"></slot>
        </div>
        <slot></slot>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    borders: {
        type: Boolean,
        default: true,
    },
    title: {
        type: String,
        default: null,
    },
    desc: {
        type: String,
        default: null,
    },
    iconOptions: {
        type: Object,
        default: () => {},
    },
    order: {
        type: String || Number,
        default: null,
    },
    activateFlex: {
        type: Boolean,
        default: false
    },
    alignSelf: {
        type: String,
        default: null,
        validator: (val) => ['auto', 'start', 'end', 'center', 'baseline', 'stretch'].includes(val),
    },
    alignItems: {
        type: String,
        default: null,
        validator: (val) => {
            return ['center', 'start', 'end', 'flex-start', 'flex-end', 'normal'].includes(val)
        }
    },
    alignContent: {
        type: String,
        default: null,
        validator: (val) => {
            return ['center', 'start', 'end', 'flex-start', 'flex-end', 'normal'].includes(val)
        }
    },
    justifyContent: {
        type: String,
        default: null,
        validator: (val) => {
            return ['center', 'start', 'end', 'flex-start', 'flex-end', 'normal', 'left', 'right', 'space-between', 'space-around', 'space-evenly'].includes(val)
        }
    },
    removePadding: {
        type: Array,
        validator: (val) => {
            return val.some(item => ['x', 'y', 'a', 'l', 'r', 't', 'b'].includes(item))
        }
    },
    heightFitContent: {
        type: Boolean,
        default: false
    }
})

const computedStyles = computed(() => {
    let paddingRemovalObj = {}
    if (props.removePadding) {
        paddingRemovalObj = {
            'padding-left': props.removePadding.includes('l') ? '0' : '20px',
            'padding-right': props.removePadding.includes('r') ? '0' : '20px',
            'padding-top': props.removePadding.includes('t') ? '0' : '20px',
            'padding-bottom': props.removePadding.includes('b') ? '0' : '20px',
        }
    }
    const otherPropClasses = {
        'order': props.order,
        'align-self': props.alignSelf,
        'align-items': props.alignItems,
        'align-content': props.alignContent,
        'justify-content': props.justifyContent
    }
    const finalClassObj = {...paddingRemovalObj, ...otherPropClasses}
    return finalClassObj
})
</script>

<script>
    export default {
        name: 'AonCard'
    }
</script>

<style lang="scss">
.a-card {
    width: 100%;
    background: #fff;
    border: 1px solid transparent;
    border-radius: 12px;

    &.flex-active {
        display: flex;
        flex-wrap: wrap;
        
        &:first-child {
            width: 100%;
        }
    }

    &.borders {
        border-color: $grey04;
    }

    &.fit {
        height: fit-content;
    }

    .top {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .icon {
            cursor: pointer;
            width: 20px;
            height: 20px;
        }
    }
}
</style>
